import Fuse from 'fuse.js';
import { searchFilter } from '@shared/helpers/string.helpers';
import { MenuFuzzySearchOptions } from './menu.model';

const DEFAULT_THRESHOLD = 0.2;
const DEFAULT_MIN_MATCH_CHAR_LENGTH = 1;

/**
 * True when a menu row with {@link text} should stay visible for {@link query}.
 * An empty query (or empty text, before the label is known) shows the row.
 * A word anywhere in the label matches, including after a comma — e.g. "sound"
 * in "acoustic panel, glas wool, sound". Typos still use Fuse.
 */
export const menuItemMatchesSearch = (
  text: string,
  query: string,
  options: MenuFuzzySearchOptions = {},
): boolean => {
  if (!query) return true;
  if (!text) return true;
  if (searchFilter(text, query)) return true;

  const fuse = new Fuse([text.toLowerCase()], {
    threshold: options.threshold ?? DEFAULT_THRESHOLD,
    minMatchCharLength:
      options.minMatchCharLength ?? DEFAULT_MIN_MATCH_CHAR_LENGTH,
    ignoreLocation: true,
  });
  return fuse.search(query.toLowerCase()).length > 0;
};
